import {flow, getEnv, getRoot, types, getSnapshot, applySnapshot, getPath} from "mobx-state-tree";
import {TagSelectState} from "../../elements/tags/TagSelectState";
import {GroupSelectState} from "../../elements/groups/GroupSelectState";
import {CodeTypeSelectState} from "../../elements/codeTypes/CodeTypeSelectState";
import Group from "../../../models/Group";
import CodeType from "../../../models/CodeType";
import {ModalState} from "../../elements/modal/GenericModal";
import {StatusState} from "../../configs/status/StatusState";
import {PageTemplateSelectState} from "../../elements/pageTemplate/PageTemplateSelectState";
import {UtmModalState} from "../../utms/modal/UtmModalState";
import {RuleSetModalState} from "../../configs/rulesets/modal/RuleSetModalState";
import {Utm} from "../../../models/utms/UtmModel";
import {DimensionSelectViewState} from "../../elements/dimensions/dimensionSelectViewState";
import lodash from "lodash";
import {DesignerModalState} from "../../qr/modal/DesignerModalState";
import {createCustomAjvValidator} from "../../../services/AjvValidator";
import {codeBehavior, codeTypes, codeTypesWithBehavior} from "../../../utils/constants";
import Notification from "../../../utils/Notification";
import {validateAndFormatUrl, addTimestampToFileName, getFileFormat, getFileCategory, getValidProtocol} from "../../../utils/common";
import {ParameterSetModalState} from "../../configs/parametersets/modal/ParameterSetModalState";
import Parameters from "../../../models/Parameters";
import StateMachine from "javascript-state-machine";
import {createTransitions} from "../../../utils/buildTransitions";
import {walletExperienceDataBuilder} from "../../elements/walletPass/utils";
import {MediaFileSelectState} from "../../elements/mediaFiles/MediaFileSelectState";
import {MediaFile} from "../../../models/mediaFiles/MediaFileModel";
import {ViewFilePicState} from "../../mediaFiles/view/ViewFilePicState";
import {ExtendedDataSettingModalState} from "../../extendedData/modal/ExtendedDataSettingModalState";
import {ExtendedDataModel} from "../../../models/extendedData/ExtendedData";
import { addUtmToCode } from "../../utms/utils/UtmUtils";
import DesignerState from "../../../components/qr/designer/DesignerState";
import QrConfiguration from "../../../models/QrConfiguration";
import AuditViewState from "../audit/AuditViewState";
import {protocolConstants} from "../../../utils/constants";


const defaultSchemaJson = {
  "type": "object",
  "properties": {
    "url": {
      "title": "Landing Url:",
      "type": "string",
      "validationMessage": {
        "default": "Url must be of proper format: http(s)://...",
        "302": "Url is required"
      }
    }
  },
  "required": ["url"]
};

export const EditCodeState = types.model('EditCodeState',{
  isLoading: types.optional(types.boolean, false),
  uuid: types.optional(types.string, ""),
  name: types.optional(types.string, ""),
  nameIsValid: types.optional(types.boolean, true),
  status: types.optional(types.string, ""),
  tagSelectStore: types.maybe(types.late(() => types.reference(TagSelectState))),
  groupSelectStore: types.maybe(types.late(() => types.reference(GroupSelectState))),
  codeTypeSelectStore: types.maybe(types.late(() => types.reference(CodeTypeSelectState))),
  secondaryCodeTypeSelectStore: types.maybe(types.late(() => types.reference(CodeTypeSelectState))),
  pageTemplateSelectStore: types.maybe(types.late(() => types.reference(PageTemplateSelectState))),
  selectedGroup: types.maybe(types.reference(Group)),
  experienceSelected: types.maybe(types.reference(CodeType)),
  secondaryExperienceSelected: types.maybe(types.reference(CodeType)),
  vCardDownLoadLinkData : types.optional(types.string, ""),
  behavior:  types.optional(types.string, ""),

  selectedTags: types.optional(types.array(types.string), []),
    //types.optional(types.array(types.reference(Tag, {acceptsUndefined: true})), []),
  experienceData: types.optional(types.string, '{}'),
  secondaryExperienceData: types.optional(types.string, '{}'),
  experienceUISchema: types.optional(types.string, '{}'),
  secondaryExperienceUISchema: types.optional(types.string, '{}'),
  formHasErrors: types.optional(types.boolean, false),
  errorMessage: types.optional(types.string, "Null"),
  selectedDefaultUrl: types.optional(types.string, ''),
  inSubmission: types.optional(types.boolean, false),
  liveValidateSchema: types.optional(types.boolean, false),
  extendedDataSettingModalState: types.maybe(types.late(() => ExtendedDataSettingModalState)),
  extendedDataList: types.optional(types.array(types.safeReference(types.late(() => ExtendedDataModel))), []),


  experienceReadonly: types.optional(types.boolean, false),
  qrUrlReadonly: types.optional(types.boolean, false),

  modalStore: types.maybe(ModalState),
  statusViewState:types.maybe(types.late(() => StatusState)),
  utmModalState:types.maybe(types.late(() => UtmModalState)),
  utm:types.maybe(types.late(() => Utm)),
  ruleSetModalState:types.maybe(types.late(() => RuleSetModalState)),
  rules: types.optional(types.string, "[]"),
  designerModalState:types.maybe(types.late(() => DesignerModalState)),
  existedDesignerState: types.maybe(types.late(() => DesignerState)), // this is for storing original designer state
  imageUuid: types.optional(types.string, ""),
  parameterSetModalState:types.maybe(types.late(() => ParameterSetModalState)),
  parameters: types.maybe(Parameters),
  dimensionSelectViewState: types.maybe(types.late(() => types.reference(DimensionSelectViewState))),
  selectedDimensions: types.optional(types.string,'{}'),
  previousPlatform: types.optional(types.string, ""),
  codeStatus: types.maybe(types.string),
  mediaFileSelectState: types.maybe(types.late(() => types.reference(MediaFileSelectState))),
  mediaFile: types.maybe(MediaFile),
  auditStateRef: types.maybeNull(AuditViewState),
  mediaFiles: types.optional(types.frozen(),{}),
  viewFilePicState: types.maybeNull(ViewFilePicState),
  isView: types.optional(types.boolean, false),
  fileForS3Upload: types.optional(types.frozen(),{}),
  isAuditActionEnabled: types.optional(types.boolean, false),
  selectedProtocol: types.optional(types.enumeration([protocolConstants.HTTP, protocolConstants.HTTPS]), protocolConstants.HTTP),
}).volatile((self) => ({
  cancelUploads: types.boolean,
  modalComponent: types.object,
  modalComponentStore: types.object,
  urlListener: types.fn,
  nameListener: types.fn,
  modalSize: types.str,
  modalClassName: types.str,
  fsm: types.fn,
})).actions(self => ({
  setSelectedProtocol(protocol) {
    self.selectedProtocol = getValidProtocol(protocol);
  },
  setUuid(uuid) {
    self.uuid = uuid
  },
  handleImageUuidChange(uuid) {
    self.imageUuid = uuid
  },
  handleNameChange(e) {
    self.name = e.target.value
    self.nameIsValid = true
  },
  setCodeStatus(status) {
    self.codeStatus = status
  },
  handleHasErrors(boolean) {
    self.formHasErrors = boolean
  },
  handleErrorMessage(message) {
    self.errorMessage = message
  },
  setShortUrlListener(listener) {
    self.urlListener = listener
  },
  setNameListener(listener) {
    self.nameListener = listener;
  },
  setAuditStateListener(listener) {
    self.selectedCallback = listener
  },
  setAuditStateRef(auditRef) {
    self.auditStateRef = auditRef;
  },
  handleConfigModalPopUp(component,title,componentStore,size="",className = ""){
    self.modalComponentStore = typeof componentStore === "string" && self[componentStore]
      ? self[componentStore]
      : componentStore ?? null;
    self.modalComponent = component;
    self.modalSize=size;
    self.modalClassName=className;
    self.modalStore.toggle()
    self.modalStore.handleTitle(title)
  },
  setOnSelectChanges() {
    self.groupSelectStore.setConsumer(self.selectGroup)
    self.tagSelectStore.setConsumer(self.selectTag)
    self.codeTypeSelectStore.setConsumer(self.selectExperience)
    self.secondaryCodeTypeSelectStore?.setConsumer(self.selectSecondaryExperience)
    self.designerModalState?.setConsumer(self.handleImageUuidChange)
    self.dimensionSelectViewState?.setConsumer(self.selectDimension)
    self.mediaFileSelectState?.setConsumer(self.setMediaFileToSchema)
    self?.extendedDataSettingModalState?.setConsumer(self.selectExtendedDataSelection);
  },
  selectExtendedDataSelection(d) {
    const selectedExtendedData = self.extendedDataSettingModalState?.getSelectedExtendedDataMap() || {};
    self.setExtendedDataList(Object.values(selectedExtendedData));
  },
  setExtendedDataList(arr) {
    self.extendedDataList = arr;
  },
  selectDimension(obj,parentUuid){
    let existingDimension = JSON.parse(self?.selectedDimensions)
    existingDimension[parentUuid] = obj?.uuid
    existingDimension = lodash.pickBy(existingDimension, value => !(lodash.isEmpty(value))); // to delete empty array object
    self.selectedDimensions = JSON.stringify(existingDimension)
  },
  getDimensions(){
    if(lodash.isEmpty(JSON.parse(self.selectedDimensions))) return undefined
    return JSON.parse(self.selectedDimensions)
  },
  validateDimension(){
    if(!self.dimensionSelectViewState?.dimensionsEnabled) return true
    let dimensions = self.getSelectedDimensions()
    const dimensionUuids = self.dimensionSelectViewState?.dimensionSelectStates.map(selectState => selectState?.selectStateUuid)
    dimensionUuids.forEach(uuid => {
      if (!dimensions.hasOwnProperty(uuid)) {
        self.dimensionSelectViewState?.dimensionSelectStates?.find(selectState => selectState?.selectStateUuid == uuid).setDefaults()
      }
    })
    dimensions = self.getSelectedDimensions()
    return dimensionUuids.every(uuid => dimensions.hasOwnProperty(uuid));
  },
  getSelectedDimensions(){
    return JSON.parse(self.selectedDimensions)
  },
  selectGroup(obj) {
    self.selectedGroup = obj;
    const dimensionUuids = self.dimensionSelectViewState?.dimensionSelectStates
      .filter(selectState => selectState?.dimension?.type === "CONDITIONAL")
      .map(selectState => selectState?.selectStateUuid);
    dimensionUuids.forEach(uuid => {
      self.dimensionSelectViewState?.dimensionSelectStates?.find(selectState => selectState?.selectStateUuid == uuid).getListOnGroup(self?.selectedGroup?.uuid)
    })
  },
  selectTag(arr) {
    self.selectedTags = arr.flatMap((tag)=> tag?.uuid)
  },
  selectExperience(obj) {
    console.log('EditCodeState.selectExperience called with:', obj?.name, obj?.uuid);

    if (!self.experienceDataMap) {
      self.experienceDataMap = {};
    }
    if (self.experienceSelected) {
      self.experienceDataMap[self.experienceSelected.name] = self.experienceData;
      if (self.experienceDataMap.hasOwnProperty(obj.name)) {
        self.experienceData = self.experienceDataMap[obj.name];
      } else {
        self.experienceData = '{}';
      }
    }
    self.experienceSelected = obj;

    // Initialize MediaFileSelectState instances based on the selected experience's uiSchema
    if (obj?.uiSchema) {
      try {
        const uiSchema = JSON.parse(obj.uiSchema);
        console.log('EditCodeState.selectExperience uiSchema:', uiSchema);

        const root = getRoot(self);
        const mediaFileManager = root.rootUiStore.mediaFileSelectStateManager;

        if (mediaFileManager) {
          console.log('EditCodeState.selectExperience initializing MediaFileSelectStateManager');
          // Use MST manager to create field-specific MediaFileSelectState instances
          mediaFileManager.initializeFromUISchema(uiSchema, self.setMediaFileToSchema);
          console.log(`EditCodeState.selectExperience initialized manager with ${mediaFileManager.stateCount} states:`, mediaFileManager.fieldNames);
        } else {
          console.warn('EditCodeState.selectExperience: mediaFileManager not found');
        }
      } catch (error) {
        console.error('Failed to parse uiSchema or initialize MediaFileSelectStates:', error);
      }
    } else {
      console.warn('EditCodeState.selectExperience: no uiSchema found for experience', obj?.name);
    }
  },
  selectSecondaryExperience(obj){
    self.secondaryExperienceSelected = obj;
  },
  returnDynamic(behavior) {
    const filteredBehavior = behavior?.filter(b => b !== codeBehavior.STATIC);
    if(filteredBehavior?.length === 1) {
      return filteredBehavior[0];
    } else {
      return "";
    }
  },
  buildFSM(currentCodeType) {
    const initState = currentCodeType?.name +"|"+self?.returnDynamic(currentCodeType?.behavior);
    const transitions = createTransitions(codeTypesWithBehavior);
    let FSM = new StateMachine({
      init: initState,
      transitions: transitions
    })
    self.fsm = FSM;
    self.codeTypeSelectStore.setFsm(self.fsm);
  },
  searchGroup(txt) {
    console.log(txt)
  },
  updatePreviousPlatform(platform) {
    self.previousPlatform = platform
  },
  updateExperienceData(data) {

    if(self.isCodeTypeSocialMedia()) {
      self.updateFormData(data);
    }
    if (data.hasOwnProperty("enableWalletPass") && data?.enableWalletPass) {
      data = {
        ...data,
        ...walletExperienceDataBuilder(self.experienceSelected?.uuid, data),
      };
    }
    if (data.hasOwnProperty("passType")) {
      // For Mobile Wallet Pass experience
      ["eventTicket", "coupon", "storeCard", "generic"].forEach((t) => {
        if (data.hasOwnProperty(t) && data[t]) {
          data[t] = {
            ...data[t],
            "showMobileWalletCode": data[t].barcodeType === "None" || data[t].showMobileWalletCode
          };
        }
      });
    }
    // Parse the old data
    let oldData = JSON.parse(self.experienceData || "{}");

// Merge old data with new data (new data overrides old fields)
    let mergedData = { ...oldData, ...data };

// Save back to self.experienceData as a string
    self.experienceData = JSON.stringify(mergedData)
  },
  removeExperienceField(fieldName) {
    // Remove a specific field from experienceData to trigger re-render
    const currentData = JSON.parse(self.experienceData || "{}");
    const updatedData = { ...currentData };
    delete updatedData[fieldName];
    self.experienceData = JSON.stringify(updatedData);
  },
  updateSecondaryExperienceData(data) {
    if (self.secondaryExperienceSelected?.name === codeTypes.SocialMedia) {
      self.updateFormData(data);
    }
    if (data.hasOwnProperty("enableWalletPass") && data?.enableWalletPass) {
      data = {
        ...data,
        ...walletExperienceDataBuilder(self.secondaryExperienceSelected?.uuid, data),
      };
    }
    if (data.hasOwnProperty("passType")) {
      // For Mobile Wallet Pass experience
      ["eventTicket", "coupon", "storeCard", "generic"].forEach((t) => {
        if (data.hasOwnProperty(t) && data[t]) {
          data[t] = {
            ...data[t],
            "showMobileWalletCode": data[t].barcodeType === "None" || data[t].showMobileWalletCode
          };
        }
      });
    }
    self.secondaryExperienceData = JSON.stringify(data)
    console.log(self.toJSON())
  },
  addVCardDownLoadLinkData(data) {
    self.vCardDownLoadLinkData = JSON.stringify(data)
  },
  experienceExtendedDataView() {
    return self.extendedDataSettingModalState?.formData;
  },
  updateExperienceUISchema(uiSchema="{}") {
    self.experienceUISchema = uiSchema;
  },
  updateSecondaryExperienceUISchema(uiSchema="{}") {
    self.secondaryExperienceUISchema = uiSchema;
  },
  updateExperienceUISchemaOnData(data) {
    let uiSchema = JSON.parse(self.experienceUISchema);
    if (data.hasOwnProperty("passType")) {
      // For Mobile Wallet Pass experience
      ["eventTicket", "coupon", "storeCard", "generic"].forEach((t) => {
        if (uiSchema.hasOwnProperty(t) && data[t]) {
          uiSchema[t] = {
            ...uiSchema[t],
            "showMobileWalletCode": {
              "ui:readonly": data[t].barcodeType === "None"
            }
          };
        }
      });
    }

    if(self.experienceSelected.uuid === codeTypes.GS1) {
      uiSchema = self.updateGs1UISchema(data)
    }

    self.updateExperienceUISchema(JSON.stringify(uiSchema));
  },
  updateGs1UISchema(data) {
    if (lodash.get(data, 'keyQualifiers.mode') === "MAIN") {
      const experienceData = JSON.parse(self.experienceData);
      const keyQualifiersToOmit = [
        'serialNumber',
        'variant',
        'expirationDate',
        'dataAttributes'
      ];

      lodash.update(experienceData, 'keyQualifiers', keyQualifiers =>
        lodash.omit(keyQualifiers, keyQualifiersToOmit)
      );

      self.experienceData = JSON.stringify(experienceData);

      return {
        keyQualifiers: {
          mode: {
            "ui:widget": "toggleButtonGroup",
            "ui:options": { "label": false }
          },
          ...lodash.fromPairs(keyQualifiersToOmit.map(key => [key, { "ui:widget": "hidden" }]))
        }
      };
    }
    return {};
  },
  updateSecondaryExperienceUISchemaOnData(data) {
    let uiSchema = JSON.parse(self.secondaryExperienceUISchema);
    if (data.hasOwnProperty("passType")) {
      // For Mobile Wallet Pass experience
      ["eventTicket", "coupon", "storeCard", "generic"].forEach((t) => {
        if (uiSchema.hasOwnProperty(t) && data[t]) {
          uiSchema[t] = {
            ...uiSchema[t],
            "showMobileWalletCode": {
              "ui:readonly": data[t].barcodeType === "None"
            }
          };
        }
      });
    }
    self.updateSecondaryExperienceUISchema(JSON.stringify(uiSchema));
  },
  updateFormData(data) {
    const platformDefaults = {
      "Facebook": ["Follow", "Share"],
      "Instagram": "Follow",
      "YouTube": ["Watch", "Subscribe"],
      "LinkedIn": "Connect",
      "Pinterest": "Follow",
      "Reddit": ["Follow", "Join"],
      "Snapchat": "Follow",
      "Telegram": "Follow",
      "TikTok": ["Follow", "Share"],
      "Tumblr": "Follow",
      "X (Twitter)": ["Follow", "Tweet"],
      "Line": "Add"
    };

    if (data.platform !== self.previousPlatform) {
      self.updatePreviousPlatform(data.platform);
      if (platformDefaults.hasOwnProperty(data.platform)) {
        data.username = "";
      }
    }

    if (Array.isArray(platformDefaults[data.platform])) {
      if (platformDefaults[data.platform].includes(data.action)) {
        data.action = data.action;
      } else {
        data.action = platformDefaults[data.platform][0];
      }
    } else {
      if (data.action === platformDefaults[data.platform]) {
        data.action = data.action;
      } else {
        data.action = platformDefaults[data.platform];
      }
    }
  },

  fetchMediaFileUrls: flow(function* (obj) {
    if (typeof obj !== "object" || obj === null) {
      throw new Error("Input must be a valid object.");
    }

    for (const [key, value] of Object.entries(obj)) {
      const manager = getEnv(self).mediaFileManager;
      const response = yield manager.getFileLocation(value);
      self.updateExperienceData({...JSON.parse(self.experienceData),[key]: response?.liveLinks?.original})

    }
  }),

  hydrateForm: flow(function* f(code){
    if (Object.values(code?.mediaFiles ?? {})[0]) {
      self.experienceSelected = code?.type

      // Use manager to hydrate media file states
      try {
        const root = getRoot(self);
        const mediaFileManager = root.rootUiStore.mediaFileSelectStateManager;
        const apiMediaFileManager = getEnv(self).mediaFileManager;

        if (mediaFileManager && apiMediaFileManager) {
          // Initialize the manager with the experience's uiSchema
          if (self.experienceSelected?.uiSchema) {
            const uiSchema = JSON.parse(self.experienceSelected.uiSchema);
            mediaFileManager.initializeFromUISchema(uiSchema, self.setMediaFileToSchema);
          }

          // Use the manager's built-in hydration method
          const hydrationResult = yield mediaFileManager.hydrateFromCodeData(code, apiMediaFileManager);

          console.log(`Hydrated ${hydrationResult.hydratedCount} media file states`);

          // Create a generic MediaFile for widget compatibility using the hydration result
          if (hydrationResult.hydratedCount > 0) {
            const genericMediaFile = hydrationResult.createGenericMediaFile();
            if (genericMediaFile) {
              self.mediaFile = genericMediaFile;
            }
          }
        } else {
          console.warn('MediaFileSelectStateManager hydration skipped:', {
            hasManager: !!mediaFileManager,
            hasApiManager: !!apiMediaFileManager,
            experienceType: self.experienceSelected?.name
          });
        }
      } catch (error) {
        console.error('Failed to hydrate media file states using manager:', error);
        // Fallback to original logic if needed
      }
    }

    self.name = code?.name
    self.secondaryExperienceSelected = code?.dataDetail?.secondaryExperience?.type
    self.codeTypeSelectStore.setDefaultCodeType(code?.type)
    code?.dataDetail?.secondaryExperience?.type && self.secondaryCodeTypeSelectStore.setDefaultCodeType(code?.dataDetail?.secondaryExperience?.type)
    if( code?.behavior === codeBehavior.STATIC){
    self.selectedDefaultUrl = code?.shortUrl?.uri
    }else{
    self.selectedDefaultUrl = code?.shortUrl?.domain + "/" + code?.shortUrl?.uri
    }
    self.behavior = code?.behavior
    self.experienceData = JSON.stringify(code?.data)
    self.secondaryExperienceData = JSON.stringify(code?.dataDetail?.secondaryExperience?.data)
    self.extendedDataSettingModalState?.hydrateModal(code);
    self.pageTemplateSelectStore.setStyles(code?.dataDetail?.styles)
    self.groupSelectStore.selectGroup(code?.owner?.groupUuid)
    self.tagSelectStore.setSelectedTags(code?.tags?.flatMap((tag)=> tag.uuid))
    self.statusViewState.setStatus(code?.status)
    self.setCodeStatus(code?.status)
    self.utmModalState.utm.hydrateUtm(code?.utm)
    self.parameters.hydrateParameters(code?.parameters)
    self.rules = JSON.stringify(code.rules)
    self.mediaFiles = code?.mediaFiles
    if(code?.statusDetail?.schedule){
      self.statusViewState.setStatusScheduleData(code?.statusDetail?.schedule)
      self.statusViewState.setScheduleStatusChange()
    }
    if(code?.owner?.dimensions){
       self.dimensionSelectViewState.setDimensions(code?.owner?.dimensions)
    }
    // Set protocol from fetched code (new format or old format)
    if (code?.shortUrl) {
      if (code.shortUrl.protocol) {
        self.setSelectedProtocol(code.shortUrl.protocol);
      } else if (code.shortUrl.domain) {
        const protocol = code.shortUrl.domain.startsWith(protocolConstants.HTTPS) ? protocolConstants.HTTPS : protocolConstants.HTTP;
        self.setSelectedProtocol(protocol);
      }
    }
      self.utm = Utm.create({
        uuid: "editCode",
        campaign: code.utm?.campaign,
        source: code.utm?.source,
        medium: code.utm?.medium,
        term: code.utm?.term,
        content: code.utm?.content,
        utmParametersConfigs: {
          campaignSelectValue: code?.utm?.utmParametersConfigs?.campaignSelectValue,
          sourceSelectValue: code?.utm?.utmParametersConfigs?.sourceSelectValue,
          mediumSelectValue: code?.utm?.utmParametersConfigs?.mediumSelectValue,
          termSelectValue: code?.utm?.utmParametersConfigs?.termSelectValue,
          contentSelectValue: code?.utm?.utmParametersConfigs?.contentSelectValue,
        }
      })
    if(self.mediaFiles !== undefined && self.mediaFiles !== "") {
      self.fetchMediaFileUrls(self.mediaFiles)
    }
  }),

  fetchWithID: flow(function* f(){
    if(self.uuid === "") return
    self.isLoading = true
    const manager = getEnv(self).codeManager
    const res = yield manager.fetchQrcodeWithId(self.uuid)
    self.urlListener(  res?.behavior === codeBehavior.STATIC ? res?.shortUrl?.uri : res?.shortUrl?.domain + "/" + res?.shortUrl?.uri)
    self.hydrateForm(res)
    self.nameListener(res?.name);
    self.isLoading = false
    return res // needs to return to fetch image from server with image config uuid
  }),
  validateSchema(schema, formData) {
    const ajv = createCustomAjvValidator().ajv;
    const validate = ajv.compile(schema)
    let valid = validate(formData)
    if (!valid) {
      self.liveValidateSchema = true
    }
    if(self.name === "") {
      self.nameIsValid = false
      valid = false
    }
    return valid
  },
  validateForm() {
    const experienceData = JSON.parse(self.experienceData);
    let isExperienceFormValid = self.validateSchema(JSON.parse(self.experienceSelected.schema), experienceData)
    if(self.experienceSelected.uuid === 'gs1' && experienceData?.keyQualifiers?.mode !== "SUB") {
      isExperienceFormValid = isExperienceFormValid && self.validateSchema(JSON.parse(self.secondaryExperienceSelected.schema), JSON.parse(self.secondaryExperienceData));
    }
    if (self?.getExtendedDataList()?.length) {
      const isExtenedFormValid = self.extendedDataSettingModalState?.validateForm();
      return isExperienceFormValid && isExtenedFormValid;
    }
    return isExperienceFormValid;
  },
  updateCode: flow(function* f() {
    // TODO: validate Input
    if (self.experienceSelected.name === "appLink") {
      const experienceDataObj = JSON.parse(self.experienceData);

      try {
        ["fallback", "playStore", "appStore"].forEach((key) => {
          validateAndFormatUrl({
            url: experienceDataObj[key],
            targetObj: experienceDataObj,
            key
          });
        });

        self.experienceData = JSON.stringify(experienceDataObj);
      } catch (e) {
        new Notification()
          .setType("error")
          .setMessage(e.message)
          .send();
        self.isLoading = false;
        return;
      }
    }
    if (
      self.experienceSelected.name === "url" ||
      self.experienceSelected.name === "socialMedia" ||
      self.experienceSelected.name === "gs1"
    ) {
      const experienceDataObj = JSON.parse(self.experienceData);
      const secondaryExperienceDataObj = JSON.parse(self.secondaryExperienceData);

      try {
        validateAndFormatUrl({
          url: experienceDataObj.url,
          targetObj: experienceDataObj,
          key: "url"
        });
        self.experienceData = JSON.stringify(experienceDataObj);

        if (self.experienceSelected.name === "gs1") {
          validateAndFormatUrl({
            url: secondaryExperienceDataObj.url,
            targetObj: secondaryExperienceDataObj,
            key: "url"
          });
          self.secondaryExperienceData = JSON.stringify(secondaryExperienceDataObj);
        }
      } catch (e) {
        new Notification()
          .setType("error")
          .setMessage(e.message)
          .send();
        self.isLoading = false;
        return;
      }
    }
    const validSchema = self.validateForm()
    if (validSchema) {
    self.isLoading = true
    if(!self.validateDimension()) {
      //TODO: Make this generic for all validations
      new Notification()
        .setType("error")
        .setMessage(`select atleast one dimensions each`)
        .send();
      self.isLoading = false
      return
    }
    const imageConfigManager = getEnv(self).imageConfigManager
    try {
      // first check designer config id, if it is noDesign open, remove the image config
      // else update the image config
      const designerViewStore = self?.designerModalState?.designerViewStore
      designerViewStore.updateExtendConfig("showImageSizeOrModuleWidth", designerViewStore.imageCharsStore.showImageSizeOrModuleWidth)
      designerViewStore.cleanSizeAndModuleWidth()
      const { extendConfig } = designerViewStore
      if (self?.imageUuid !== "") {
        const updatedImageConfig = yield imageConfigManager.updateApplyToCode(extendConfig, self?.imageUuid, self?.designerModalState?.defaultImageConfig, self?.designerModalState?.v1ImageConfig, self?.designerModalState?.designerViewStore?.logoStore)
      } else if (extendConfig !== "{}") {
        const newImageConfigUuid = yield imageConfigManager.addImageConfigForCode(self?.designerModalState, extendConfig)
        self.imageUuid = newImageConfigUuid
      }
    } catch (e) {
      console.error("Error in Designer Template Update:", e);
      return
    }
    const manager = getEnv(self).codeManager
    const resp = yield manager.update(self);
    self.formHasErrors && new Notification()
      .setType("error")
      .setMessage(`${self.name} Code failed updating: ${self.errorMessage}`)
      .send();
    !self.formHasErrors && new Notification()
      .setType("success")
      .setMessage(`${self.name} Code updated`)
      .send()
    //&& self.urlListener(self.selectedDefaultUrl ? self.selectedDefaultUrl : "hi")
    self.handleHasErrors(false)
    self.isLoading = false
    return resp
    }else{
      return null
    }
  }),
  addRulesToCode(){
    const rules = self.ruleSetModalState.createRuleSetState.grabRuleSetForCode()
    if(rules?.length > 0){
      self.rules = self.ruleSetModalState.noRuleOpen? "[]": rules
      return self.rules
    }else{
      return null
    }
  },
  addUtmToCode(){
    // if ( self.utmModalState.noUtmOpen || !self.utmModalState.utm.doesUtmHaveValue()){
    //   self.utm = Utm.create({uuid:"noUtm"})
    // }else{
    //   self.utm = self.utmModalState.utm.grabUtmForCode()
    // }
    addUtmToCode(self)
  },
  addParameterSetToCode() {
    if (!self.parameterSetModalState.noParameterSetOpen) {
      self.parameters.setParameters("codeParamType",self.parameterSetModalState.codeParamsTypeSelectState.selectedCodeParameters.map((param) => param.uuid))
      self.parameters.setParameters("scanParamType",self.parameterSetModalState.scanParamsTypeSelectState.selectedScanParameters.map((param) => param.uuid))
      self.parameters.setParameters("countParamType",self.parameterSetModalState.countParamsTypeSelectState.selectedCountParameters.map((param) => param.uuid))
      self.parameters.setParameters("premiumParamType",self.parameterSetModalState.premiumParamsTypeSelectState.selectedPremiumParameters.map((param) => param.uuid))
      self.parameters.setParameters("customParamType",self.parameterSetModalState.customParamsTypeSelectState.selectedCustomParameters.map((param) => param.uuid))
      self.parameters.setParameters("gs1ParamType",self.parameterSetModalState.gs1ParamsTypeSelectState.selectedGS1Parameters.map((param) => param.uuid))
      self.parameters.setParameters("edParamType", self.parameterSetModalState.parameterExtendedDataSelectStore.selectedExtendedData.map((param) => param.uuid))

    } else if (self.parameterSetModalState.noParameterSetOpen || !self.parameterSetModalState.doesParamsHaveValues()) {
      self.parameters.clearParams()
    }
  },
  addExperienceFieldAndMediaFileUuid(uuid,experienceFieldName) {
    if(uuid && experienceFieldName){
    self.mediaFiles = {...self.mediaFiles, [experienceFieldName]:uuid}
    }
  },
  setMediaFileToSchema(file, experienceFieldName) {
    self.addExperienceFieldAndMediaFileUuid(file?.uuid, experienceFieldName)
    if (file?.uuid) {
      if (["eps"].includes(file.fileFormat) && file.liveLinks?.png) {
        self.updateExperienceData({
          [experienceFieldName]: file.liveLinks?.png,
          "fileType": getFileCategory("png")
        })
      } else if (file.liveLinks?.original) {
        self.updateExperienceData({
          [experienceFieldName]: file.liveLinks?.original,
          "fileType": getFileCategory(file.fileFormat)
        })
      } else {
        new Notification()
          .setType("info")
          .setTitle(`File: ${file.label}`)
          .setMessage("Is processing. Can take 30 seconds")
          .send();
        self.updateExperienceData({[experienceFieldName]: ""})
      }
    } else if (file?.name) { // reason for no uuid is that there is no location for new file yet.
      self.updateExperienceData({[experienceFieldName]: ""})
    }
  },
  setFileForS3Upload(file,singleUseFile){
    self.fileForS3Upload = file
    self.mediaFile.setFileForS3Upload(file, singleUseFile)
  },
  selectMediaFile(mediaFile){
    self.mediaFile.updateMediaFile(mediaFile)
  },
  handleFilePicState(image){
    self.viewFilePicState = ViewFilePicState.create({fileImageUrl: image})
  },
  updateSingleUseMediaFile: flow(function* (mediaFile, experienceFieldName, mediaFileSelectState = null) {
    return yield self.mediaFile.updateSingleUseMediaFile(mediaFile, experienceFieldName, mediaFileSelectState, self);
  }),
  updateMediaFile: flow(function* (mediaFile, experienceFieldName, mediaFileSelectState = null) {
    return yield self.mediaFile.updateMediaFileResponse(mediaFile, experienceFieldName, mediaFileSelectState, self);
  }),
  setCancelUploads(value) {
    self.cancelUploads = value
    self.mediaFile.setCancelUploads(value, self)
  },
  waitForMediaFileUpload: flow(function* (mediaFileUUID, experienceFieldName, mediaFileSelectState = null) {
    return yield self.mediaFile.waitForMediaFileUpload(mediaFileUUID, experienceFieldName, mediaFileSelectState, self);
  }),
  createMediaFileFromWidget: flow(function* f(experienceFieldName, mediaFileSelectState = null) {
    return yield self.mediaFile.createMediaFileFromWidget(experienceFieldName, mediaFileSelectState, self);
  }),
  updateDesignerModalState(designerModalState) {
    try {
      applySnapshot(self.designerModalState.designerViewStore, getSnapshot(designerModalState.designerViewStore))
      const after = getSnapshot(self.designerModalState)
      console.log("Updater node", self.designerModalState);
    } catch (error) {
      console.error("Error in Designer Template Update:", error);
    }
  },
  afterCreate() {
  }
})).views((self) => ({
  configButtonColor(bool) {
    return bool ? "secondary" : "primary"
  },
  configClassName(bool) {
    return bool ? "btn-outline-secondary mr-1 mb-1" : "btn-outline-primary mr-1 mb-1"
  },
  shouldRenderURL(){
    return self.behavior !== codeBehavior.STATIC
  },
  shouldRenderExtendedData() {
    return true; // todo: default for all?
  },
  hasExtendedData() {
    return Object.keys(self.getExtendedDataList())?.length && self.extendedDataSettingModalState?.showDropdown;
  },
  getExtendedDataList() {
    return self.extendedDataList?.filter(n => n);
  },
  getExtendedDataRequest() {
    return self.hasExtendedData() ? {
      "items": self?.getExtendedDataList()?.map((item) => item.uuid),
      "data": self?.experienceExtendedDataView()
    } : null;
  },
  shouldRenderUTMConfig() {
    return (self.experienceSelected?.name === codeTypes.URL || self.experienceSelected?.name === codeTypes.GS1)
      && self.behavior === codeBehavior.DYNAMIC
  },
  shouldRenderParametersConfig() {
    return (self.experienceSelected?.name === codeTypes.URL || self.experienceSelected?.name === codeTypes.GS1)
      && self.behavior === codeBehavior.DYNAMIC
  },
  shouldRenderRulesConfig() {
    return (self.experienceSelected?.name === codeTypes.URL || self.experienceSelected?.name === codeTypes.GS1)
      && self.behavior === codeBehavior.DYNAMIC
  },
  shouldRenderStatusConfig() {
    return self.experienceSelected?.behavior?.includes(codeBehavior.DYNAMIC) && self.behavior === codeBehavior.DYNAMIC
  },
  shouldRenderSecondTabInPreview(){
    return self.behavior === codeBehavior.DYNAMIC
  },
  isCodeTypeSocialMedia() {
    return self.experienceSelected?.name === codeTypes.SocialMedia
  },
  experienceDataView() {
    return JSON.parse(self.experienceData)
  },
  secondaryExperienceDataView() {
    return JSON.parse(self.secondaryExperienceData)
  },
  experienceSchemaJson() {
    //TODO: this method is being called everytime code form fields like name or url is changed, needs refactoring
    let {schema} = self.experienceSelected || {}
    console.log("Schema is :" + schema);
    schema = schema || JSON.stringify(defaultSchemaJson);
    return JSON.parse(schema);
  },
  secondaryExperienceSchemaJson() {
    let {schema} = self.secondaryExperienceSelected || {}
    console.log("Schema is :" + schema);
    schema = schema || JSON.stringify(defaultSchemaJson);
    return JSON.parse(schema);
  },
  experienceUISchemaView() {
    if(self.experienceSelected){

    let {uiSchema} = self.experienceSelected;
    self.updateExperienceUISchema(JSON.stringify({
      ...JSON.parse(uiSchema || '{}'),
      ...JSON.parse(self.experienceUISchema)
    }));
    return JSON.parse(self.experienceUISchema);
    }
  },
  secondaryExperienceUISchemaView() {
    const secondaryExperience = self.secondaryExperienceSelected || {};
    let {uiSchema} = secondaryExperience;
    self.updateSecondaryExperienceUISchema(JSON.stringify({
      ...JSON.parse(uiSchema || '{}'),
      ...JSON.parse(self.secondaryExperienceUISchema)
    }));
    return JSON.parse(self.secondaryExperienceUISchema);
  },
  parametersHaveValue() {
    return self.parameters.codeParamType.length > 0
      || self.parameters.scanParamType.length > 0
      || self.parameters.countParamType.length > 0
      || self.parameters.premiumParamType.length > 0
      || self.parameters.customParamType.length > 0
      || self.parameters.gs1ParamType.length > 0
      || self.parameters.edParamType.length > 0
  },
  isStatusNotDefault() {
    return (self.codeStatus != "PUBLISHED" || self.statusViewState.scheduleStatusChange);
  }
}))
